import { detectEnvironment } from "@shared/helpers";

import { enviroment } from "@shared/constants";

const BFF_BASE_URLS = {
  dev: `${window?.location?.origin || ""}/bff-proxy/service/core`,
  hml: "https://hml-bff.barte.com/service/core",
  sandbox: "https://sandbox-bff.barte.com/service/core",
  prd: "https://bff.barte.com/service/core/",
} as const;

export const env = detectEnvironment();

export const BFF_BASE_URL = BFF_BASE_URLS?.[env] || BFF_BASE_URLS.prd;

const N8N_BASE_URLS = {
  dev: `${window?.location?.origin || ""}/n8n-proxy/webhook/`,
  prd: "https://prdc-n8n-webhook.barte.com/webhook/",
} as const;

export const N8N_BASE_URL = N8N_BASE_URLS?.[env] || N8N_BASE_URLS.prd;

const API_BASE_URLS = {
  dev: `${window?.location?.origin || ""}/api-proxy/`,
  sandbox: "https://sandbox-api.barte.com/",
  prd: `https://api.barte.com/`,
} as const;

export const API_BASE_URL = API_BASE_URLS?.[env] || API_BASE_URLS.prd;
